import React from 'react';
import { Dialog } from './Dialog.js';
import { Button } from './Button.js';

export interface ConfirmDialogProps {
  open?: boolean;
  isOpen?: boolean;
  title: string;
  description?: string;
  message?: string;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  busy?: boolean;
  isSubmitting?: boolean;
  'data-testid'?: string;
  testId?: string;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  isOpen,
  title,
  description,
  message,
  confirmLabel,
  cancelLabel = 'انصراف',
  tone = 'primary',
  onConfirm,
  onCancel,
  onClose,
  busy = false,
  isSubmitting = false,
  'data-testid': dataTestId,
  testId
}) => {
  const isDialogOpen = Boolean(open ?? isOpen);
  const handleCancel = onCancel ?? onClose ?? (() => {});
  const bodyText = description ?? message;
  const isBusy = Boolean(busy || isSubmitting);
  const testIdValue = dataTestId || testId || 'confirm-dialog';
  const isDanger = tone === 'danger';

  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCancel}
      title={title}
      size="sm"
      closeOnEsc={!isBusy}
      closeOnOverlayClick={false}
      data-testid={testIdValue}
      footer={
        <>
          <Button
            variant={isDanger ? 'danger' : 'primary'}
            size="md"
            onClick={onConfirm}
            loading={isBusy}
            autoFocus={!isDanger}
            data-autofocus={!isDanger ? 'true' : undefined}
            data-testid={`${testIdValue}-confirm`}
          >
            {confirmLabel}
          </Button>
          <Button
            variant="ghost"
            size="md"
            onClick={handleCancel}
            disabled={isBusy}
            autoFocus={isDanger}
            data-autofocus={isDanger ? 'true' : undefined}
            data-testid={`${testIdValue}-cancel`}
          >
            {cancelLabel}
          </Button>
        </>
      }
    >
      {bodyText ? (
        <p className="text-sm text-base-content/80 leading-relaxed py-1">
          {bodyText}
        </p>
      ) : null}
    </Dialog>
  );
};

ConfirmDialog.displayName = 'ConfirmDialog';
